/**
 * 基础菜单 商品管理
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导师列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" ref="formInline" :model="formInline" class="user-search">
      <!-- <el-form-item prop="id" label="红娘ID:">
        <el-input  clearable v-model="formInline.id" placeholder="请输入红娘ID"></el-input>
      </el-form-item> -->
      <el-form-item prop="teacherId" label="红娘导师:">

        <el-select clearable v-model="formInline.teacherId" placeholder="请选择红娘导师">
          <el-option v-for="item in options123" :key="item.code" :label="item.desc" :value="item.code">
          </el-option>
        </el-select>


        <!-- <el-input  clearable v-model="formInline.name" placeholder="请输入红娘导师"></el-input> -->
      </el-form-item>
      <el-form-item prop="phone" label="手机号码:">
        <el-input type="number" clearable v-model="formInline.phone" placeholder="请输入手机号码"></el-input>
      </el-form-item>
      <el-form-item prop="platformType" label="展示平台 ">
        <el-select v-model="formInline.platformType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option v-for="item in PlatformTypeOptions" :key="item.value" :value="item.value"
                     :label="item.label"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="title" label="导师头衔:">


        <el-select clearable v-model="formInline.title" placeholder="请选择">
          <el-option v-for="item in options456" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="serviceType" label="业务类型:">
        <el-select clearable v-model="formInline.serviceType" placeholder="请选择">
          <el-option v-for="item in options789" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>

      </el-form-item>
      <el-form-item prop="isIndex" label="推荐状态:">
        <el-select v-model="formInline.isIndex" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="0"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item prop="seekType" label="咨询类型:">
        <el-select v-model="formInline.seekType" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="免费咨询" value="0"></el-option>
          <el-option label="付费咨询" value="1"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item prop="status" label="状态:">
        <el-select v-model="formInline.status" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="启用" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>

        </el-select>
      </el-form-item>

      <el-form-item prop="type" label="导师类型:">
        <el-select v-model="formInline.type" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="红娘团队" value="1"></el-option>
          <el-option label="形象打造" value="2"></el-option>
          <el-option label="情感咨询" value="3"></el-option>
          <el-option label="心理咨询" value="4"></el-option>


        </el-select>
      </el-form-item>
      <el-form-item prop="isVideo" label="是否有视频:">
        <el-select v-model="formInline.isVideo" placeholder="不限">
          <el-option label="不限" value=""></el-option>
          <el-option label="没有" value="0"></el-option>
          <el-option label="有" value="1"></el-option>


        </el-select>
      </el-form-item>

      <el-form-item prop="createBeginTime" label="创建时间">
        <el-col :span="11">
          <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期"
                          v-model="formInline.createBeginTime" style="width: 100%;"></el-date-picker>
        </el-col>
        <el-col class="line" :span="2">&nbsp;&nbsp;&nbsp;&nbsp;-</el-col>
        <el-col :span="11">
          <el-form-item prop="createEndTime">
            <el-date-picker value-format="yyyy-MM-dd HH:mm:ss" default-time="['23:59:59']" type="datetime"
                            placeholder="选择日期"
                            v-model="formInline.createEndTime" style="width: 100%;"></el-date-picker>
          </el-form-item>


        </el-col>
      </el-form-item>
      <el-form-item label="订单数量" prop="beginOrderNum">
        <el-col :span="4">
          <el-input clearable v-model="formInline.beginOrderNum" placeholder="不限"></el-input>
        </el-col>
        <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
        <el-col :span="5">
          <el-form-item label="" prop="endOrderNum">
            <el-input clearable v-model="formInline.endOrderNum" placeholder="不限"></el-input>
          </el-form-item>

        </el-col>
      </el-form-item>
      <el-form-item style="float: right;">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button icon="el-icon-delete" type="info" @click="resetForm('formInline')">重置</el-button>
        <!-- <el-button  type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button @click="resetForm('formInline')">重置</el-button> -->
      </el-form-item>
      <div style=" float: right; margin-right: 50px; margin-bottom: 0px; ">

        <el-button type="success" icon="el-icon-plus" @click="handleEdit()">添加</el-button>

      </div>
    </el-form>
    <el-table id="educe-table" ref="multipleTable" stripe :data="listData" highlight-current-row v-loading="loading"
              @select-all="selectall" @select="select" border element-loading-text="拼命加载中"
              style="width: 100%; font-size: 18px;">

      <el-table-column prop="id" align="center" label="红娘ID" width="100">
        <template slot-scope="scope">
          <span style="font-size: 29px; font-weight: 600;  color: #885DDF;">{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="image" label="红娘照片" width="180">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px;" :src="scope.row.image" :preview-src-list="[scope.row.image]"/>
        </template>
      </el-table-column>
      <el-table-column prop="platformTypeDesc" align="center" label="展示平台" width="150">
      </el-table-column>
      <el-table-column prop="name" align="center" label="导师名称" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.name }}({{ scope.row.realName }})</div>
          <el-tag style="margin-top: 20px;">{{ scope.row.title }}</el-tag>


        </template>

      </el-table-column>
      <el-table-column prop="name" align="center" label="业务类型" width="120">
        <template slot-scope="scope">

          <el-tag style=" margin-top: 10px; " v-for="(item, index) in scope.row.serviceType" :key="index"
                  type="success">{{ item }}
          </el-tag>
        </template>

      </el-table-column>

      <el-table-column prop="phone" align="center" label="手机号码" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.phone, userifom|mobileStr }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="serviceYears" align="center" label="工作年限" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.serviceYears }}年</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="serviceNums" align="center" label="服务会员" width="140">
        <template slot-scope="scope">
          <span>实际:{{ scope.row.orderNum }}位</span><br>
          <span style='color: green ;'>虚拟:{{ scope.row.serviceNums }}位</span>
        </template>
      </el-table-column>
      <el-table-column prop="serviceHours" align="center" label="咨询小时" width="150">
        <template slot-scope="scope">
          <span>实际:{{ scope.row.realServiceHours }}小时</span><br>
          <span style='color: green;'>虚拟:{{ scope.row.serviceHours }}小时</span>
        </template>
      </el-table-column> -->

      <el-table-column align="center" prop="version" label="创建时间" width="200">
        <template slot-scope="scope">
          <div>{{ scope.row.createTimeMills | timestampToTime }}</div>
          <br>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="version" label="咨询金额" width="120">
        <template slot-scope="scope">
          <div>¥{{ scope.row.cost }}元</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="priceMinute" label="咨询分钟" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.priceMinute }}分钟</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" align="center" label="订单数量" width="100">
        <template slot-scope="scope">
          <span>男:{{ scope.row.manOrderNum }}</span><br>
          <span>女:{{ scope.row.womanOrderNum }}</span><br>
          <span>总计:{{ scope.row.orderNum }}</span>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="indexs" label="推荐状态" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.indexs == 0">否</div><br>
          <div style="color: green;" v-if="scope.row.indexs > 0">是{{ scope.row.indexs }}</div><br>

        </template>
      </el-table-column>
      <el-table-column align="center" prop="indexs" label="状态" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == 1" type="success">启用</el-tag>
          <el-tag v-if="scope.row.status == 0" type="danger">禁用</el-tag>
          <!-- <div>{{scope.row.status== }}</div><br> -->

        </template>
      </el-table-column>


      <el-table-column align="center" fixed="right" prop="version" label="操作" width="380">
        <template slot-scope="scope">
          <el-button @click="handleEdit('l', scope.row)" icon="el-icon-edit" type="primary">编辑</el-button>
          <el-button v-if="scope.row.indexs == 0" @click="handleEdit(3, scope.row)" icon="el-icon-mouse"
                     type="success">推荐
          </el-button>
          <el-button v-if="scope.row.indexs != 0" type="info" @click="recommend(-1, scope.row)">取消推荐</el-button>
          <el-button v-if="scope.row.videoIndexs!=0" type="info" @click="recommends(-1, scope.row)">取消直播推荐
          </el-button>
          <el-button v-if=" scope.row.videoIndexs==0" @click="handleEdit(4, scope.row)" icon="el-icon-mouse"
                     type="primary">直播推荐
          </el-button>

        </template>
      </el-table-column>


    </el-table>

    <!--列表-->

    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" style="float: right; margin-right:0px; height: 50px; margin-top: 50px;"
                @size-change="handleSizeChange" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <div style="margin-top: 20px;">
      <!-- <el-button @click="selectallsdss(listData)" type="primary">全选</el-button> -->
      <!-- <el-button @click="deleList(listData)" type="primary">删除</el-button> -->


    </div>

    <el-dialog :destroy-on-close='true' :close-on-click-modal="false" :title="title" @close="closeDialog" ref="editForm"
               center :visible.sync="editFormVisible" width="60%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">


        <el-form-item label="展示平台" prop="platformType">
          <el-checkbox-group v-model="editForm.platformType">
            <el-checkbox v-for="item in PlatformTypeOptions" :key="item.value" :label="item.value.toString()">{{item.label}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <br/>
        <el-form-item label="导师类型:" prop="type">
          <el-radio-group v-model="editForm.type">
            <el-radio :label="1">专业红娘</el-radio>
            <el-radio :label="2">形象打造</el-radio>
            <el-radio :label="3">情感咨询</el-radio>
            <el-radio :label="4">心理咨询</el-radio>

          </el-radio-group>
        </el-form-item>
        <el-form-item label="导师名称:" prop="name">
          <el-input maxlength="3" style="width: 300px;" v-model="editForm.name" auto-complete="off"
                    placeholder="列入:胡老师"></el-input>
        </el-form-item>

        <el-form-item label="导师真实名称:" prop="realName">
          <el-input maxlength="6" style="width: 300px;" v-model="editForm.realName" auto-complete="off"
                    placeholder="请输入导师真实名称"></el-input>
        </el-form-item>
        <el-form-item prop="title" style="width: 80%; margin-left: 0px;" label="导师头衔:">
          <div style="margin-left: 0; margin-top: -68px;">
            <el-radio-group style="float: left; margin-left: 20px;" :max="1" v-model="editForm.title"
                            v-for=" (item, index) in options456" :key="index">
              <el-radio style="margin-top: 20px;" :label="item" :city="item">
              </el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <br/>

        <div style="width: 100%; height: 200px;">

          <el-form-item style="float: left;" label="导师照片:" prop="image">
            <el-upload :class="{ disabled: uploadDisabled }" :action="ssoServerimg" list-type="picture-card" :limit="1"
                       :on-exceed="Onexceed" multiple :on-change="uploadSectionFile" :before-upload="beforeUpload"
                       :file-list="fileList" :on-success="handleAvatarSuccess" :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemove">
              <i class="el-icon-plus"></i>
            </el-upload>
            <span style="color: red;">建议尺寸 1:1</span>
          </el-form-item>
          <el-form-item style="float: left;" label="导师企业微信:" prop="wechatQrCode">
            <el-upload :class="{ disabled: uploadDisableds }" :action="ssoServerimg" list-type="picture-card" :limit="1"
                       :on-exceed="Onexceed" multiple :on-change="uploadSectionFiles" :before-upload="beforeUpload"
                       :file-list="fileLists" :on-success="mentorAvatarSuccess" :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemoves">
              <i class="el-icon-plus"></i>
            </el-upload>

            <span style="color: red;">建议尺寸 1:1</span>
          </el-form-item>
          <el-form-item style="float: left;" label="导师视频封面:" v-if="editForm.video">
            <el-upload :class="{ disabled: uploadDisabledslz }" :action="ssoServerimg" list-type="picture-card"
                       :limit="1"
                       :on-exceed="Onexceed" multiple :on-change="uploadSectionFileslz" :before-upload="beforeUpload"
                       :file-list="fileListslz" :on-success="mentorAvatarSuccesslz"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemoveslz">
              <i class="el-icon-plus"></i>
            </el-upload>

            <span style="color: red;">建议尺寸 1:1</span>
          </el-form-item>
          <el-form-item style="float: left;" label="导师视频背景:" prop="videoBackground" v-if="editForm.video">
            <el-upload :class="{ disabled: uploadDisabledsgd }" :action="ssoServerimg" list-type="picture-card"
                       :limit="1"
                       :on-exceed="Onexceed" multiple :on-change="uploadSectionFilesgd" :before-upload="beforeUpload"
                       :file-list="fileListsgd" :on-success="mentorAvatarSuccessgd"
                       :on-preview="handlePictureCardPreview"
                       :on-remove="handleRemovesgd">
              <i class="el-icon-plus"></i>
            </el-upload>

            <span style="color: red;">建议尺寸 1:1</span>
          </el-form-item>
        </div>
        <el-form-item style="margin-top: 100px;" label="导师视频:">
          <el-upload v-if="!editForm.video" :class="{ disabled: videoAvatar }" :action="ssoServerimg"
                     list-type="picture-card" :limit="1" :on-exceed="Onexceed" multiple :on-change="uploadSectionvideo"
                     :before-upload="beforeUpload" :file-list="fileListsVideo" :on-success="videoAvatarSuccess"
                     :on-preview="handlePictureCardPreview" :on-remove="handlevideoRemoves">
            <i class="el-icon-plus"></i>
          </el-upload>

          <div v-if="editForm.video" style="width: 30%;height: 100px;">
            <video-player :options="playerOptions"></video-player>
            <el-button style="float: left;" @click="delevideo" type="success">删除</el-button>
          </div>
          <span style="color: red; float: left; ">请上传16:9视频尺寸,仅支持上传一个
          </span>
        </el-form-item>

        <!-- <video  src="editForm.video"></video> -->
        <el-form-item prop="serviceType" style="width: 70%; margin-left: 0px;" label="业务类型:">
          <div style="margin-left: 0; margin-top: -38px;">
            <el-checkbox-group style="float: left; margin-left: 20px;" :max="3" v-model="editForm.serviceType"
                               v-for=" (item, index) in options789" :key="index">
              <el-checkbox :label="item" :city="item">
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-form-item>

        <el-form-item v-if="iFstatic == 1" label="状态:" prop="status">
          <el-radio-group v-model="editForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="工作年限:" prop="serviceYears">
          <el-input type="number" maxlength="20" style="width: 300px;" v-model="editForm.serviceYears"
                    auto-complete="off"
                    placeholder="请输入工作年限">
            <template slot="append">年限</template>
          </el-input>
        </el-form-item>
        <el-form-item label="手机号码:" prop="phone">
          <el-input type="number" oninput="if(value.length > 11) value=value.slice(0, 11)" maxlength="11"
                    style="width: 300px;" v-model="editForm.phone" auto-complete="off"
                    placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="服务会员:" prop="serviceNums">
          <el-input type="number" maxlength="20" style="width: 300px;" v-model="editForm.serviceNums"
                    auto-complete="off"
                    placeholder="请输入服务会员">
            <template slot="append">人数</template>
          </el-input>
        </el-form-item>
        <el-form-item label="咨询费用:" prop="cost">
          <el-input type="number" maxlength="20" style="width: 300px;" v-model="editForm.cost" auto-complete="off"
                    placeholder="请输入服务会员">
            <template slot="append">费用</template>
          </el-input>
        </el-form-item>
        <el-form-item label="点赞数量:" prop="likeNum" v-if="editForm.video">
          <el-input type="number" maxlength="20" style="width: 300px;" v-model="editForm.likeNum" auto-complete="off"
                    placeholder="请输入点赞次数">
            <template slot="append">数量</template>
          </el-input>
        </el-form-item>
        <el-form-item label="咨询分钟数:" prop="priceMinute">
          <el-input type="number" maxlength="20" style="width: 300px;" v-model="editForm.priceMinute"
                    auto-complete="off"
                    placeholder="请输入咨询分钟数">
            <template slot="append">分钟</template>
          </el-input>

        </el-form-item>
        <el-form-item label="咨询小时:" prop="serviceHours">
          <el-input type="number" maxlength="20" style="width: 300px;" v-model="editForm.serviceHours"
                    auto-complete="off"
                    placeholder="请输入咨询小时">
            <template slot="append">小时</template>
          </el-input>
        </el-form-item>

        <el-form-item label="个人介绍:" prop="introduce">
          <el-input type="textarea" placeholder="请输入个人介绍" v-model="editForm.introduce" maxlength="1000"
                    show-word-limit>
          </el-input>
        </el-form-item>
        <el-form-item label="从业资质:" prop="qualifications">
          <el-input type="textarea" placeholder="请输入从业资质" v-model="editForm.qualifications" maxlength="1000"
                    show-word-limit>
          </el-input>
          <span style="color: red;">描述中间增加“，”，逗号视为空格键</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog('editForm')">取消</el-button>
        <el-button type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>


    <el-dialog :visible.sync="dialogVisiblesss">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <el-dialog title="温馨提示" @close="oncloseDialog" :close-on-click-modal="false" :visible.sync="editFormVisiblesY"
               width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

        <span style="margin-left: 52px;">确定要将该活动推荐吗？</span><br>

        <el-form-item label="推荐排序" prop="deptName">
          <el-input style="width: 200px;" type="number" v-model="recommendform.index" auto-complete="off"
                    placeholder="请输入排序"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="oncloseDialog">取消</el-button>
        <el-button type="primary" :loading="loading" class="title" @click="onRecommend('editForm')">确定推荐</el-button>
      </div>
    </el-dialog>

    <!-- 直播推荐 -->
    <el-dialog title="温馨提示" @close="oncloseDialog" :destroy-on-close="false" :close-on-click-modal="false"
               :visible.sync="editFormVisibleslook"
               width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">

        <span style="margin-left: 52px; ">确定要将该红娘设为直播区域推荐吗？</span><br>

        <el-form-item label="推荐排序" style="margin-top: 30px;" prop="deptName">
          <el-input style="width: 200px;" type="number" v-model="recommendforms.index" auto-complete="off"
                    placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="oncloseDialogs">取消</el-button>
        <el-button type="primary" :loading="loading" class="title" @click="onRecommends('editForm')">确定推荐
        </el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Vue from 'vue'
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import * as imageConversion from 'image-conversion';
import Axios from 'axios'
let tokenId = localStorage.getItem('tokenId');
import Pagination from '../../components/Pagination'
import {PlatformTypeOptions} from "../../enums/userEnum";

export default {
  computed: {
    PlatformTypeOptions() {
      return PlatformTypeOptions
    }
  },
  data() {
    return {
      dialogImageUrl: '',
      userifom: "",
      fileList: [],
      ssoServer: "",
      ssoServerimg: "",
      fileListlll: [],
      fileLists: [],
      fileListslz: [],
      fileListsgd: [],

      fileListsVideo: [],

      playerOptions: {
        // 视频 url
        sources: [{
          src: '',
          type: 'video/mp4'
        }],
        // 其他设置项
        autoplay: true,
        controls: true,
        poster: 'http://path/to/poster.jpg',
      },
      ggetid: '',
      iFstatic: '5',
      listsss: [],
      dialogVisible: false,
      fileDetailList: [],
      editFormVisiblesY: false,
      editFormVisibleslook: false,
      addserss: "",
      dialogVisiblesss: false,
      recommendform: {
        index: '',
        id: ''
      },
      recommendforms: {
        index: '',
        id: ''
      },

      uploadDisabled: false,
      uploadDisableds: false,
      uploadDisabledslz: false,
      uploadDisabledsgd: false,
      optionsx: [
        {item: "微信小程序", index: '1'},
        {item: "抖音小程序", index: '2'},
        {item: "PC官网", index: '3'},
        {item: "移动官网", index: '4'},
      ],
      videoAvatar: false,
      indexs: "",
      formInline: {
        platformType: [],
        teacherId: "",
        isVideo: "",
        type: "",
        realName: '',
        platform: "",
        seekType: "",
        endOrderNum: '',
        beginOrderNum: '',
        name: '',
        id: "",
        platformd: "",
        releaseAddress: "",
        serviceType: '',
        isIndex: '',
        phone: "",
        title: "",
        status: "",
        createBeginTime: "",
        createEndTime: "",
        current: 1,
        size: 20,
        // token: localStorage.getItem('logintoken')
      },

      dialogFormVisibleicn: false,
      activeName: '1',
      userlist: "",
      radio: "",

      dialogFormVisible: false,
      checkList: [],
      adder: "",
      options123: [],
      options456: [],
      options789: [],
      undataList: "",
      options1234123: [],
      nshow: true, //switch开启
      fshow: false, //switch关闭
      importList: [],
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加导师',

      editForm: {
        platformType: [],
        likeNum: "",
        videoBackground: "",//导师视频封面
        videoCover: '',//导师背景封面
        type: "",//导师类型
        video: "",//导师视频
        cost: '',//咨询费用
        realName: '',//导师真实姓名
        priceMinute: "",//咨询分钟数
        qualifications: '',//从业资质
        wechatQrCode: '',//导师企业微信
        status: "",//状态
        serviceYears: '',//工作年限
        name: '',//导师名称
        title: '',//导师头衔
        serviceType: [],//业务类型
        serviceNums: '',//服务会员
        serviceHours: '',//咨询小时
        introduce: "",//个人介绍
        image: '',//导师图片
        phone: '',//手机号码

      },

      // rules表单验证
      rules: {
        addDeer: [
          {required: true, message: '请选择位置', trigger: 'blur'}
        ],
        platformType: [{required: true, message: '展示平台不能为空', trigger: 'blur'}],
        videoCover: [{required: true, message: '导师视频封面不能为空', trigger: 'blur'}],
        likeNum: [{required: true, message: '点赞数量不能为空', trigger: 'blur'}],
        video: [{required: true, message: '导师视频不能为空', trigger: 'blur'}],
        type: [{required: true, message: '导师类型不能为空', trigger: 'blur'}],
        cost: [{required: true, message: '咨询费用不能为空', trigger: 'blur'}],
        wechatQrCode: [{required: true, message: '导师企业微信不能为空', trigger: 'blur'}],
        priceMinute: [{required: true, message: '咨询分钟数不能为空', trigger: 'blur'}],
        realName: [{required: true, message: '导师真实昵称不能为空', trigger: 'blur'}],
        name: [{required: true, message: '导师昵称不能为空', trigger: 'blur'}],
        title: [{required: true, message: '导师头衔不能为空', trigger: 'blur'}],
        serviceType: [{required: true, message: '业务类型不能为空', trigger: 'blur'}],
        serviceYears: [{required: true, message: '工作年限不能为空', trigger: 'blur'}],

        serviceNums: [{required: true, message: '服务会员不能为空', trigger: 'blur'}],
        serviceHours: [{required: true, message: '咨询小时不能为空', trigger: 'blur'}],
        introduce: [{required: true, message: '个人介绍不能为空', trigger: 'blur'}],
        phone: [{required: true, message: '手机号码不能为空', trigger: 'blur'}],
        // status: [{ required: true, message: '不能为空', trigger: 'blur' }],


        subTitle: [{required: true, message: '副标题不能为空', trigger: 'blur'}],
        platform: [{required: true, message: '发布平台不能为空', trigger: 'blur'},
          {min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur'}
        ],

        // images: [{ required: true, message: '视频封面不能为空', trigger: 'blur' }],
        releaseTime: [{required: true, message: '指定发布日期不能为空', trigger: 'blur'}],
        releaseAddress: [{required: true, message: '发布地址不能为空', trigger: 'blur'},
          {min: 0, max: 20, message: '长度在 0 到 20 个字符', trigger: 'blur'}
        ],
        content: [{required: true, message: '内容不能为空', trigger: 'blur'}],
        image: [{required: true, message: '导师照片不能为空', trigger: 'blur'}]
      },

      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10
      }
    }
  },

  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServerimg = Vue.prototype.GLOBAL.ssoServerimg
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer
    let tokenId = localStorage.getItem('tokenId');
    this.adder = tokenId


    // this.getdata(this.formInline)
  },
  mounted() {
    this.userifom = localStorage.getItem('userifom');
    this.formLIst()
    this.getAddress()
    // this.getAddresss()

    Axios({
      method: 'get',
      url: this.ssoServer + '/api//platform-wonderful-atlas/releaseAddressList',
      headers: {
        tokenId: this.adder
      },

    }).then(res => {
      if (res.data.code == 999) {
        setTimeout(() => {
          localStorage.removeItem('tokenId')

          this.$store.commit('logout', 'false')
          this.$router.push({path: '/login'})
          this.$message({
            type: 'success',
            message: '登录过期,请重新登录'
          })
        }, 1000)
      }
      this.addserss = res.data.data


    })


    Axios({
      method: 'get',
      url: this.ssoServer + '/api/teacher/getTitleList',
      headers: {
        tokenId: this.adder
      }
    }).then(res => {

      this.options456 = res.data.data

    })
    Axios({
      method: 'get',
      url: this.ssoServer + '/api/teacher/getServiceTypeList',
      headers: {
        tokenId: this.adder
      }
    }).then(res => {

      this.options789 = res.data.data

    })
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 从新上传
    delevideo() {
      this.editForm.video = ''
      this.playerOptions.sources[0].src = ''
      this.fileListsVideo = []
      this.videoAvatar = false

    },
    recommend(i, f) {
      if (i == -1) {
        this.recommendform.id = f.id
        this.recommendform.index = 0

        this.$confirm('确定要将该活动推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Axios({
            method: 'post',
            url: this.ssoServer + '/api/teacher/updateIndex',
            headers: {
              tokenId: this.adder
            },
            data: this.recommendform
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.recommendform.index = ''
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      } else {
        // this.editFormVisible = true

      }
      this.recommendform.id = f.id


      this.recommendform.index = ''

    },
    recommends(i, f) {
      if (i == -1) {
        this.recommendforms.id = f.id
        this.recommendforms.index = 0

        this.$confirm('确定要将该直播推荐取消吗?', '温馨提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          Axios({
            method: 'post',
            url: this.ssoServer + '/api/teacher/updateVideoIndex',
            headers: {
              tokenId: this.adder
            },
            data: this.recommendforms
          }).then(res => {
            if (res.data.code == 0) {
              this.$message({
                type: 'success',
                message: '取消成功'
              })
              this.recommendforms.index = ''
              this.formLIst()
            }
          })

        }).catch(() => {

        });
        return

      } else {
        // this.editFormVisible = true

      }
      this.recommendforms.id = f.id


      this.recommendforms.index = ''

    },


    beforeUpload(file) {
      const isLt50M = file.size / 1024 / 1024 < 30;
      if (!isLt50M) {
        this.$message.error('上传视频大小不能超过 30MB!');
        this.videoAvatar = false
        return
      }
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/gif" || file.type === "video/mp4";
      if (file.type == "video/mp4") {
        var isLt2M = file.size / 1024 / 1024 < 30;
      } else {
        var isLt2M = file.size / 1024 / 1024 < 2;
      }

      if (!isJpgOrPng) {
        this.$message.error("上传图片/视频只能是 JPG 或 PNG 或 MP4 格式!");
        return
      }
      return new Promise((resolve) => {
        // 小于2M 不压缩
        if (isLt2M) {
          resolve(file)
        }
        //压缩到400KB,这里的400就是要压缩的大小,可自定义
        imageConversion.compressAccurately(file, 400).then((res) => {
          console.log(res);
          resolve(res);
        });
      });
    },
    Onexceed() {
      console.log();
    },


    uploadSectionFile(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisabled = true;
      }
    },
    uploadSectionFiles(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisableds = true;
      }
    },
    uploadSectionFileslz(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisabledslz = true;
      }
    },

    uploadSectionFilesgd(file, fileList) {
      if (fileList.length >= 1) {
        this.uploadDisabledsgd = true;
      }
    },



    uploadSectionvideo(file, fileList) {
      if (fileList.length >= 1) {
        this.videoAvatar = true;
      }
    },

    handleAvatarSuccess(res, file) {
      // console.log(file);
      // this.listsss.push(res.data)
      this.editForm.image = res.data


    },
    mentorAvatarSuccess(res, file) {
      this.editForm.wechatQrCode = res.data
    },
    mentorAvatarSuccesslz(res, file) {
      this.editForm.videoCover = res.data
    },
    mentorAvatarSuccessgd(res, file) {
      this.editForm.videoBackground = res.data
    },
    videoAvatarSuccess(res, file) {
      // console.log(11111);
      // this.resizeVideo(res.data)
      this.playerOptions.sources[0].src = res.data
      this.editForm.video = res.data
    },
    oncloseDialog() {
      this.editFormVisiblesY = false
      this.recommendform.index = ''
    },
    oncloseDialogs() {
      this.editFormVisibleslook = false
      this.recommendforms.index = ''
    },
    onRecommend(editData) {
      // this.$refs[editData].validate(valid => {
      //   if (valid) {
      if (this.recommendform.index == '') {
        return this.$message({
          type: 'warning',
          message: '推荐排序不能为空'
        })
      }
      Axios({
        method: 'post',
        url: this.ssoServer + '/api/teacher/updateIndex',

        headers: {
          tokenId: this.adder
        },
        data: this.recommendform
      }).then(res => {
        if (res.data.code == 0) {
          this.$message({
            type: 'success',
            message: '推荐成功'
          })
          this.recommendform.index = ''
          this.editFormVisiblesY = false
          this.formLIst()

        } else {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
          return

        }


      })
      //   }
      // })
    },
    onRecommends(editData) {
      // this.$refs[editData].validate(valid => {
      //   if (valid) {
      if (this.recommendforms.index == '') {
        return this.$message({
          type: 'warning',
          message: '推荐排序不能为空'
        })
      }
      Axios({
        method: 'post',
        url: this.ssoServer + '/api/teacher/updateVideoIndex',

        headers: {
          tokenId: this.adder
        },
        data: this.recommendforms
      }).then(res => {
        if (res.data.code == 0) {
          this.$message({
            type: 'success',
            message: '推荐成功'
          })
          this.recommendform.index=''
          this.editFormVisibleslook=false
          this.formLIst()

        } else {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
          return

        }


      })
      //   }
      // })
    },
    // 删除数据
    deleList() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'success',
          message: '删除的用户不能为空!'
        });
      } else {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {


          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });

      }



    },

    selectallsdss(rows) {
      // console.log("rows : "+JSON.stringify(rows));
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {

        this.$refs.multipleTable.clearSelection();//清除全选
        console.log('2222');

      }


    },
    handleRemove(file, fileList) {
      // console.log(index);
      this.uploadDisabled = false;
      let newfileList = fileList.map((item) => {
        return item.url
      });
      this.editForm.image = newfileList;
      this.listsss = newfileList;
      console.log(this.editForm.image);


    },
    handleRemoves(file, fileList) {
      this.uploadDisableds = false;
      // console.log(index);
      let newfileList = fileList.map((item) => {
        return item.url
      });
      this.editForm.wechatQrCode = newfileList;
      // this.listsss=newfileList;
    },
    handleRemoveslz(file, fileList) {
      this.uploadDisabledslz = false;
      // console.log(index);
      let newfileListlz = fileList.map((item) => {
        return item.url
      });
      this.editForm.videoCover = newfileListlz;
      // this.listsss=newfileListlz;
    },
    handleRemovesgd(file, fileList) {
      this.uploadDisabledsgd = false;
      // console.log(index);
      let newfileListlz = fileList.map((item) => {
        return item.url
      });
      this.editForm.videoBackground = newfileListlz;
      // this.listsss=newfileListlz;
    },


    handlevideoRemoves(file, fileList) {
      this.videoAvatar = false;
      // console.log(index);
      let newfileList = fileList.map((item) => {
        return item.url
      });
      this.editForm.video = newfileList;
      this.fileListsVideo = newfileList;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisiblesss = true;
    },
    //添加

    // 确定审核
    OndialogVisible() {

      Axios({
        method: 'post',
        url: this.ssoServer + '/api/platform-nick-name-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          //   appearanceScore:this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogVisible = false
          this.$message({
            type: 'success',
            message: '审核成功'
          })
          this.formLIst()
        }
      })





    },
    // 查看历史图片
    historyHeadIcons(item) {
      this.historyHea = item
      // console.log(item);
      this.dialogFormVisibleicn = true

    },
    // 颜值打分
    YZdialogFormVisible() {
      if (!this.radio) {
        this.$message({
          type: 'warning',
          message: '选择不能为空'
        })
        return
      }
      Axios({
        method: 'post',
        url: this.ssoServer + '/api/platform-head-icon-check/operate',
        headers: {
          tokenId: this.adder
        },
        data: {
          appearanceScore: this.radio,
          accountIds: this.importList,
          operatorUserId: 1,

        }
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        }
        if (res.data.code == 0) {
          this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: '打分成功'
          })
          this.formLIst()
        }
        // // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

    },
    handleCheckedCitiesChange() {
      console.log(this.checkList);
    },
    caozClick() {
      if (this.importList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择要审核的用户'
        })
        return

      } else {
        this.dialogVisible = true
        console.log('1111');
      }

    },

    handleClick(tab, event) {
      //  return  console.log(this.activeName);
      if (this.activeName == 1) {
        this.formInline.status = 1
        this.formLIst()
      } else if (this.activeName == 2) {
        this.formInline.status = 2
        this.formLIst()
      } else if (this.activeName == 3) {
        this.formInline.status = 3
        this.formLIst()
      }

    },

    getAddress() {
      Axios({
        method: 'get',
        url: this.ssoServer + '/api/teacher/teacherList',
        headers: {
          tokenId: this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options123 = res.data.data

      })
    },


    change1(e) {
      console.log("change1", e);
      if (e.length === 1) {
        this.$message({
          type: 'error',
          message: '请选择详细地址'
        })
      }
      if (e.length === 2) {
        this.formInline.registerAddress = e[1];
      }
    },

    handleEdit(index, row) {
      if (index == 3) {
        this.editFormVisiblesY = true
        this.recommendform.id = row.id
        return
      }
      if(index==4){
        this.recommendforms.index=''
        this.editFormVisibleslook=true
        this.recommendforms.id = row.id
        return
      }
      this.iFstatic = 0
      this.editFormVisible = true


      if (row != undefined && row != 'undefined') {
        this.fileLis = []
        this.fileList.push({
          'url': row.image
        })
        this.fileLiss = []
        this.fileLists.push({
          'url': row.wechatQrCode
        })

        if(row.videoCover){
          this.fileListslz = []
        this.fileListslz.push({
          'url': row.videoCover
        })
        this.uploadDisabledslz=true
        }else{
          this.uploadDisabledslz=false

        }


        if(row.videoBackground){
          this.fileListsgd = []
        this.fileListsgd.push({
          'url': row.videoBackground
        })
        this.uploadDisabledsgd=true
        }else{
          this.uploadDisabledsgd=false

        }

        // this.editForm.videoCover=row.videoCover


        if (row.video) {
          this.fileListsVideo = []
          this.fileListsVideo.push({
            'url': row.video
          })
          this.playerOptions.sources[0].src = row.video
        }
        if (row.image.length >= 1 || row.wechatQrCode.length >= 1 || row.videoCover.lengthd >= 1) {
          this.uploadDisabled = true;
          this.uploadDisableds = true;
          // this.uploadDisabledslz = true;
          this.videoAvatar = false

        } else {
          this.uploadDisabled = false;
          this.uploadDisableds = false;
          this.uploadDisabledslz = false;
          this.videoAvatar = false
        }
        this.editForm = row

        let addlist =[]
        row.platformType.forEach(element => {
     addlist.push(String(element))
        });
        this.editForm.platformType=addlist


        // this.editForm.
        this.iFstatic = 1
        this.indexs = 2
        this.title = '编辑导师'

      } else {
        // this.editForm=''
        this.fileLis = ''
        this.uploadDisabled = false,
          this.uploadDisableds = false,
          this.uploadDisabledslz = false,
          this.videoAvatar = false,
          this.videoCover = ''
        this.indexs = 1
        this.title = '添加导师'
        this.fileList = []

        this.listsss = []
        this.editForm.realName = ''
        this.editForm.name = ''
        this.editForm.type = ""
        this.editForm.video = ""
        this.editForm.platformType=[]
        this.editForm.wechatQrCode = ''
        this.editForm.content = ''
        this.editForm.releaseAddress = ''
        this.editForm.platform = ''
        this.editForm.releaseTime = ''
        this.editForm.subTitle = ''
        this.editForm.image = ''
        this.editForm.likeNum = ''
        this.editForm.title = ''
        this.editForm.qualifications = ''
      }
    },

    selectalls(rows) {
      this.userlist = rows
      this.indexs = 2
      if (this.indexs == 2) {
        this.title = '编辑banner'

        let add = String(rows.type)
        let adds =String(rows.platformType)
        //  return  console.log(add);
        this.editFormVisible = true
        this.editForm = this.userlist
        this.editForm.type = add
        // this.editForm.platformType=adds
        this.editForm
      }

      // this.undataList =rows

      console.log(rows);
    },

    onChanges(e) {
      // console.log(e);
      this.formInline.releaseAddress = e[1]
      // console.log( this.formInline.registerAddress);
    },
    selectall(val) {
      console.log(val);

      let data = []
      // this.importList=''
      val.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // this.importList
      console.log(val);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    imporList() {
      if (this.importList.length == 0) {

        this.$message({
          type: 'warning',
          message: '请选择要导出的数据'
        })
        return

      } else {
        Axios({
          method: 'post',

          url: this.ssoServer + '/api/platform-account/exportExcel',
          headers: {
            tokenId: this.adder
          },
          data: {
            accountIds: this.importList
          },
          responseType: 'blob'
        }).then(res => {
          const link = document.createElement('a') // 创建a标签
          const blob = new Blob([res.data], { type: 'application/vnd.ms-excel;charset=UTF-8' })
          link.href = window.URL.createObjectURL(blob)
          const filename = res.headers['content-disposition'].split('filename=')[1]
          link.download = decodeURIComponent(filename) // 如果需要自定义下载文件名，则手动设置
          link.click()
          window.URL.revokeObjectURL(link.href)
        })


      }




    },
    select(selection, row) {

      let data = []
      // this.importList=''
      selection.forEach((item) => {
        data.push(item.id)
        this.importList = data
        console.log(this.importList);

      })

      // console.log(this.importList);
      // console.log(selection);
    },
    resetForm(formInline) {
      this.$refs[formInline].resetFields();
    },


    formLIst() {
      // let accountListReqVO= this.formInline
      Axios({
        method: 'get',
        url: this.ssoServer + '//api/teacher/getList',
        headers: {
          tokenId: this.adder
        },
        params: this.formInline
      }).then(res => {
        if (res.data.code == 999) {
          setTimeout(() => {
            localStorage.removeItem('tokenId')

            this.$store.commit('logout', 'false')
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '登录过期,请重新登录'
            })
          }, 1000)
        } else if (res.data.code == 500) {
          this.$message({
            type: 'warning',
            message: res.data.message
          })
        }
        this.listData = res.data.data.list
        this.pageparm.currentPage = this.formInline.current
        this.pageparm.pageSize = this.formInline.size
        this.pageparm.total = res.data.data.total
        // console.log(res);
      })

    },
    formatData(row, column, cellValue, index) {

      //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
      //最终返回 s 就可以了
      var s = new Date(cellValue).toLocaleString();
      return s;

      // 测试参数含义：不知道参数是什么含义的就打印出来
      // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
      // console.log(column)  	//拿到列的信息
      // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
      // console.log(index)     //拿到索引
    },

    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      // 模拟数据开始
      let res = {
        code: 0,
        msg: null,
        count: 5,

      }
      this.loading = false

      // 模拟数据结束

      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      deptList(parameter)

    },
    handleSizeChange(e) {
      // reru console.log(e.pageSize);
      this.formInline.size = e.pageSize
      this.formInline.current = e.currentPage

      this.formLIst()
      // console.log(e);
    },
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {

      this.formInline.current = 1
      this.formLIst()


    },

    submitForm(editForm) {
      // return console.log(this.editForm);
      // if(!this.editForm.videoCover){
      //   this.editForm.videoCover=''
      // }


      this.$refs[editForm].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          setTimeout(() => {
            if(this.editForm.video && !this.editForm.videoCover){
              this.$message({
                      type: 'warning',
                      message: '导师视频封面不能为空'
                    })
                    loading.close();
                  return

            }
      //       if(this.editForm.cost >0 && this.editForm.platformType!=1){
      //   this.$message({
      //     message: '付费导师暂不支持抖音平台，请取消抖音平台',
      //     type: 'warning'
      //   });
      //   loading.close();
      //   return
      // }
            // if(!this.editForm.video && this.editForm.videoCover){
            //   this.$message({
            //           type: 'warning',
            //           message: '导师视频不能为空'
            //         })
            //         loading.close();
            //       return

            // }

            if (this.indexs == 1) {
              Axios({
                method: 'post',
                url: this.ssoServer + '//api/teacher/add',
                headers: {
                  tokenId: this.adder
                },
                data: this.editForm
              }).then(res => {
                if (res.data.code == 999) {
                  setTimeout(() => {
                    localStorage.removeItem('tokenId')

                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '登录过期,请重新登录'
                    })
                  }, 1000)
                }
                // return console.log(res.data.code);
                if (res.data.code == 0) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '添加成功'
                  })
                  this.listsss = []
                  this.formLIst()


                }

              })


            } else {

              Axios({
                method: 'post',
                url: this.ssoServer + '/api/teacher/edit',
                headers: {
                  tokenId: this.adder
                },
                data: this.editForm
              }).then(res => {
                if (res.data.code == 999) {
                  setTimeout(() => {
                    localStorage.removeItem('tokenId')

                    this.$store.commit('logout', 'false')
                    this.$router.push({ path: '/login' })
                    this.$message({
                      type: 'success',
                      message: '登录过期,请重新登录'
                    })
                  }, 1000)
                }
                // return console.log(res.data.code);
                if (res.data.code == 0) {
                  this.editFormVisible = false
                  this.$message({
                    type: 'success',
                    message: '编辑成功'
                  })
                  this.fileLis = []
                  //   this.editForm.image=''
                  this.formLIst()
                }

              })




              console.log('编辑');
            }
            loading.close();
          }, 500);




        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },

    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deptDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('公司删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(editForm) {
      this.editForm.serviceYears = ''
      this.editForm.realName = ''
      this.editForm.name = ''
      this.editForm.wechatQrCode = '',
        this.editForm.priceMinute = ''
      this.editForm.title = ''
      this.editForm.serviceType = []
      this.editForm.platformType=''
      this.editForm.cost = ''
      this.editForm.serviceNums = ''
      this.editForm.serviceHours = ''
      this.editForm.image = ''
      this.editForm.type = ""
      this.editForm.video = ""
      this.editForm.introduce = ''
      this.editForm.qualifications = ''

      this.editForm.phone = ''

      this.formLIst()
      this.fileList = []
      this.fileLists = []
      this.fileListslz = []
      this.fileListsgd=[]
      this.fileListsVideo = []

      // this.$refs[editForm].resetFields();
      this.editFormVisible = false
      // this.editFormVisibles = false
    }
  }
}
</script>

<style >
.vjs_video_3-dimensions {
  width: 340px;
  height: 268px;
}

.vjs_video_3214-dimensions {
  width: 340px;
  height: 268px;
}

.el-upload-list__item {
  transition: none !important;
}

.disabled .el-upload--picture-card {
  display: none !important;
}

.dialogForm {
  width: 100%;
  /* height: 600px; */
  /* background-color: red; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  .dialogFormChl {
    margin-top: 20px;

    /* flex: 1; */
    width: 23%;
    border-radius: 15px;
    /* border: 1px solid #ccc; */
    height: 300px;

  }

  .dialogFormChl img {
    width: 100%;
    height: 200px;
  }
}

.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>





// WEBPACK FOOTER //
// src/views/Mentor/addMentor.vue